import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  darken,
  Dialog,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

export default function Settings({
  settingsOpen,
  title = 'Einstellungen',
  setSettingsOpen,
  options,
}) {
  const [section, setSection] = useState(options?.[0]?.key || '');
  const theme = useTheme();

  return (
    <Dialog
      open={settingsOpen}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '90%',
          width: '1200px',
          display: 'flex',
          flexDirection: 'row',
        },
      }}
      onClose={() => setSettingsOpen(false)}
    >
      <Button
        sx={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          bgcolor: '#f2eeeeff',
          '&:hover': { backgroundColor: '#e0e0e0ff' },
        }}
        onClick={() => setSettingsOpen(false)}
      >
        <Close sx={{ color: 'gray' }} />
      </Button>
      <Box
        sx={{
          p: 2,
          left: 0,
          height: '100%',
          backgroundColor: darken(theme.palette.background.paper, 0.07),
          minWidth: '300px',
          maxWidth: '30%',
          display: 'flex',
          flexFlow: 'column',
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <MenuList sx={{ height: '760px' }}>
          {options &&
            options.map((option) => (
              <MenuItem
                key={option.key}
                onClick={(evt) => {
                  evt.preventDefault();
                  setSection(option.key);
                }}
                sx={{
                  pl: 1,
                  height: '38px',
                  borderLeft:
                    section === option.key
                      ? `4px solid ${theme.palette.primary.main}`
                      : '4px solid transparent',
                  borderRadius: '4px',
                  fontWeight: section === option.key ? 'bold' : 'normal',
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    fontWeight: section === option.key ? 'bold' : 'normal',
                  }}
                >
                  {option.key}
                </ListItemText>
              </MenuItem>
            ))}
        </MenuList>
      </Box>
      <Box
        sx={{
          p: 2,
          flexDirection: 'column',
          overflow: 'auto',
          width: '100%',
        }}
      >
        {options?.find((option) => option.key === section)?.component || (
          <Typography>Keine Einstellungen verfügbar</Typography>
        )}
      </Box>
    </Dialog>
  );
}
